// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Toolbar styling */
ion-toolbar {
  padding: 0 12px;
  --background: white;
  --border-color: transparent;
  --color: var(--ion-color-secondary);
  position: relative;
  /* Leading icons */
  /* Title styling */
  /* Button container */
  /* Close/back button */
}
ion-toolbar ion-icon {
  height: 19px;
  width: 19px;
  color: var(--ion-color-secondary);
  /* Ensure icons are properly sized */
}
ion-toolbar ion-icon[slot=start] {
  margin-inline-end: 8px;
}
ion-toolbar ion-title .toolbar-title {
  font-family: AppFontBold, sans-serif !important;
  color: var(--ion-color-secondary);
  font-size: 18px;
  margin: 0;
  text-align: center;
  /* Ensure title is properly truncated if too long */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
ion-toolbar ion-buttons {
  /* Ensure buttons are properly aligned */
  display: flex;
  align-items: center;
}
ion-toolbar .toolbar-close-button {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  transition: background-color 0.2s ease, transform 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Icon within button */
}
ion-toolbar .toolbar-close-button:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
ion-toolbar .toolbar-close-button:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
ion-toolbar .toolbar-close-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
ion-toolbar .toolbar-close-button:active {
  transform: scale(0.95);
  background-color: rgba(0, 0, 0, 0.1);
}
ion-toolbar .toolbar-close-button ion-icon {
  height: 24px;
  width: 24px;
  color: var(--ion-color-secondary);
}

/* High contrast mode enhancements */
.bsg-high-contrast ion-toolbar {
  --background: white;
  border-bottom: 2px solid black;
}
.bsg-high-contrast ion-toolbar .toolbar-title {
  color: black !important;
}
.bsg-high-contrast ion-toolbar ion-icon {
  color: black !important;
}
.bsg-high-contrast ion-toolbar .toolbar-close-button:focus {
  outline: 3px solid #0078d7;
  background-color: #e6f3ff;
}
.bsg-high-contrast ion-toolbar .toolbar-close-button:hover {
  background-color: #e6f3ff;
  border: 1px solid black;
}
.bsg-high-contrast ion-toolbar .toolbar-close-button ion-icon {
  color: black !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  ion-toolbar {
    padding: 0 8px;
  }
  ion-toolbar .toolbar-title {
    font-size: 16px;
  }
  ion-toolbar .toolbar-close-button {
    min-width: 40px;
    min-height: 40px;
  }
  ion-toolbar .toolbar-close-button ion-icon {
    height: 20px;
    width: 20px;
  }
  ion-toolbar ion-icon[slot=start] {
    height: 16px;
    width: 16px;
  }
}
/* Ensure proper color contrast */
@media (prefers-contrast: high) {
  ion-toolbar .toolbar-close-button {
    border: 2px solid var(--ion-color-secondary);
  }
  ion-toolbar .toolbar-close-button:focus {
    border-color: var(--ion-color-primary);
    background-color: rgba(113, 167, 97, 0.1);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/account-toolbar/account-toolbar.component.scss"],"names":[],"mappings":"AAAA,4BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA,oBAAA;AACA;EACE,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,mCAAA;EACA,kBAAA;EAEA,kBAAA;EAYA,kBAAA;EAgBA,qBAAA;EAOA,sBAAA;AAhCF;AAFE;EACE,YAAA;EACA,WAAA;EACA,iCAAA;EAEA,oCAAA;AAGJ;AAFI;EACE,sBAAA;AAIN;AAEI;EACE,+CAAA;EACA,iCAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EAEA,mDAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADN;AAME;EACE,wCAAA;EACA,aAAA;EACA,mBAAA;AAJJ;AAQE;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,2DAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;EAMA,uBAAA;AA1BJ;AAII;EACE,2CAAA;EACA,mBAAA;AAFN;AAMI;EACE,2CAAA;EACA,mBAAA;AAJN;AAQI;EACE,qCAAA;AANN;AAUI;EACE,sBAAA;EACA,oCAAA;AARN;AAYI;EACE,YAAA;EACA,WAAA;EACA,iCAAA;AAVN;;AAeA,oCAAA;AAEE;EACE,mBAAA;EACA,8BAAA;AAbJ;AAeI;EACE,uBAAA;AAbN;AAgBI;EACE,uBAAA;AAdN;AAkBM;EACE,0BAAA;EACA,yBAAA;AAhBR;AAmBM;EACE,yBAAA;EACA,uBAAA;AAjBR;AAoBM;EACE,uBAAA;AAlBR;;AAwBA,2BAAA;AACA;EACE;IACE,cAAA;EArBF;EAuBE;IACE,eAAA;EArBJ;EAwBE;IACE,eAAA;IACA,gBAAA;EAtBJ;EAwBI;IACE,YAAA;IACA,WAAA;EAtBN;EA0BE;IACE,YAAA;IACA,WAAA;EAxBJ;AACF;AA4BA,iCAAA;AACA;EAEI;IACE,4CAAA;EA3BJ;EA6BI;IACE,sCAAA;IACA,yCAAA;EA3BN;AACF","sourcesContent":["/* Accessibility utilities */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Toolbar styling */\nion-toolbar {\n  padding: 0 12px;\n  --background: white;\n  --border-color: transparent;\n  --color: var(--ion-color-secondary);\n  position: relative;\n  \n  /* Leading icons */\n  ion-icon {\n    height: 19px;\n    width: 19px;\n    color: var(--ion-color-secondary);\n    \n    /* Ensure icons are properly sized */\n    &[slot=\"start\"] {\n      margin-inline-end: 8px;\n    }\n  }\n  \n  /* Title styling */\n  ion-title {\n    .toolbar-title {\n      font-family: AppFontBold, sans-serif !important;\n      color: var(--ion-color-secondary);\n      font-size: 18px;\n      margin: 0;\n      text-align: center;\n      \n      /* Ensure title is properly truncated if too long */\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n  \n  /* Button container */\n  ion-buttons {\n    /* Ensure buttons are properly aligned */\n    display: flex;\n    align-items: center;\n  }\n  \n  /* Close/back button */\n  .toolbar-close-button {\n    background: transparent;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 44px;\n    min-height: 44px;\n    transition: background-color 0.2s ease, transform 0.2s ease;\n    \n    /* Focus styles */\n    &:focus {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Keyboard focus styles */\n    &:focus-visible {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Hover state */\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n    \n    /* Active state */\n    &:active {\n      transform: scale(0.95);\n      background-color: rgba(0, 0, 0, 0.1);\n    }\n    \n    /* Icon within button */\n    ion-icon {\n      height: 24px;\n      width: 24px;\n      color: var(--ion-color-secondary);\n    }\n  }\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n  ion-toolbar {\n    --background: white;\n    border-bottom: 2px solid black;\n    \n    .toolbar-title {\n      color: black !important;\n    }\n    \n    ion-icon {\n      color: black !important;\n    }\n    \n    .toolbar-close-button {\n      &:focus {\n        outline: 3px solid #0078d7;\n        background-color: #e6f3ff;\n      }\n      \n      &:hover {\n        background-color: #e6f3ff;\n        border: 1px solid black;\n      }\n      \n      ion-icon {\n        color: black !important;\n      }\n    }\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  ion-toolbar {\n    padding: 0 8px;\n    \n    .toolbar-title {\n      font-size: 16px;\n    }\n    \n    .toolbar-close-button {\n      min-width: 40px;\n      min-height: 40px;\n      \n      ion-icon {\n        height: 20px;\n        width: 20px;\n      }\n    }\n    \n    ion-icon[slot=\"start\"] {\n      height: 16px;\n      width: 16px;\n    }\n  }\n}\n\n/* Ensure proper color contrast */\n@media (prefers-contrast: high) {\n  ion-toolbar {\n    .toolbar-close-button {\n      border: 2px solid var(--ion-color-secondary);\n      \n      &:focus {\n        border-color: var(--ion-color-primary);\n        background-color: rgba(113, 167, 97, 0.1);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
